export default {
  office: {
    breadcrumbHome: 'Početna',
    breadcrumbSolutions: 'Rješenja',
    breadcrumbCurrent: 'Ured i ordinacija',
    hero: {
      eyebrow: 'Ured i ordinacija',
      title: 'Diskretan nadzor za radna okruženja',
      lead: 'Recepcija, hodnici, osjetljiva područja – planiramo sustave kamera koji štite bez uznemiravanja zaposlenika ili pacijenata.',
    },
    areas: {
      title: 'Područja primjene u uredima i ordinacijama',
      lead: 'Moderni uredi i ordinacije trebaju nenametljivu sigurnosnu tehniku. Kamere suptilno integriramo u arhitekturu.',
      items: {
        '0': { title: 'Recepcija', desc: 'Prvi dojam i prva točka nadzora. Kamere na recepciji dokumentiraju posjetitelje i osiguravaju pristup.' },
        '1': { title: 'Hodnici', desc: 'Dugi hodnici često su mrtvi kutovi. Kompaktne stropne kamere neprimjetno zatvaraju praznine.' },
        '2': { title: 'Sobe za sastanke', desc: 'Ne mora se svaki sastanak snimati. Kamere postavljamo da snimaju samo relevantna područja.' },
        '3': { title: 'Serverska soba', desc: 'Prostorija u kojoj su vaši podaci zaslužuje posebnu pažnju. Pristup i aktivnost pouzdano se bilježe.' },
        '4': { title: 'Prijam u ordinaciji', desc: 'U ordinacijama je diskrecija važna. Montiramo suzdržane kamere koje ne uznemiruju pacijente.' },
        '5': { title: 'Parkiralište i ulaz', desc: 'Vanjska parkirališta i ulazi posebno su ugroženi noću. Kamere otporne na vremenske uvjete paze.' },
      },
    },
    access: {
      eyebrow: 'Pristup i kontrola',
      title: 'Tko smije što vidjeti?',
      lead: 'Sustav kamera u uredu prihvaća se samo ako su prava jasna. Postavljamo različita prava pristupa i dokumentiramo svaku upotrebu.',
      items: {
        '0': { title: 'Upravljanje korisnicima', desc: 'Svaka osoba dobiva točno ona prava koja treba – od pregleda uživo do reprodukcije snimki.' },
        '1': { title: 'Maskiranje privatnih zona', desc: 'Područja poput soba za odmor ili garderoba tehnički se skrivaju – u kameri ili snimaču.' },
        '2': { title: 'Zapisnik događaja', desc: 'Tko je što i kada pogledao? Potpun zapisnik pristupa omogućuje sljedivu kontrolu.' },
      },
    },
    privacy: {
      eyebrow: 'Zaštita podataka',
      title: 'Zaštita podataka na radnom mjestu',
      lead: 'Zaposlenici i posjetitelji uživaju posebnu zaštitu. Nadzor provodimo usklađeno i pošteno te vas savjetujemo o dokumentiranju nužnosti.',
      list: {
        '0': 'Snimanje samo tamo gdje je operativno nužno',
        '1': 'Oznake za zaposlenike i posjetitelje',
        '2': 'Bez nadzora garderoba, toaleta ili soba za odmor',
        '3': 'Pristup snimkama samo za izričito ovlaštene',
        '4': 'Dokumentacija operativne nužnosti',
      },
      note: 'Napomena: nadzor radnih mjesta podliježe strogim zakonskim zahtjevima. Savjetujemo vas tehnički, ne zamjenjujući pravni savjet.',
    },
    cta: {
      title: 'Diskretno. Uz poštivanje privatnosti. Pouzdano.',
      lead: 'Planiramo vaš uredski sustav tako da štiti, a u svakodnevici nikome ne smeta. Bez obveze i transparentno.',
      primary: 'Zakažite termin savjetovanja',
      secondary: 'Pokrenite planer kamera',
    },
  },
};